import script from "./AppLayoutMainNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutMainNew.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutMainNew.vue?vue&type=style&index=0&id=67f9f87d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f9f87d"]])

export default __exports__